<template>
  <div v-if="!!article">
    <div class="entry-heading">
      <div class="wrapper">
        <a :href="'/' + lang + '/news'" class="entry-heading__back hidden-xs" tag="a" @click.prevent="goBack()">
          {{ trans.text.news.back }}
        </a>
        <div class="entry-heading__title">
          <h1>{{ article.title }}</h1>
        </div>
        <div class="d-flex">
          <div class="entry-heading__descr" v-html="article.content.description"></div>
          <yandex-share :services="['facebook', 'linkedin', 'telegram', 'whatsapp']" class="social-wrap" counter />
        </div>
      </div>
    </div>

    <div class="entry-body">
      <template v-for="(block, index) in blocks">
        <template v-if="block.type === 'paragraph' && block.data.items.length > 0">
          <paragraph-block :key="index" :block="block"></paragraph-block>
        </template>

        <template v-if="block.type === 'header' && !!block.data.text">
          <header-block :key="index" :block="block"></header-block>
        </template>

        <template v-if="block.type === 'image'">
          <image-block :key="index" :block="block" :article="article"></image-block>
        </template>

        <div v-if="block.type == 'delimiter'" :key="index" class="wrapper w-mb2">
          <hr />
        </div>

        <template v-if="block.type == 'table'">
          <table-block :key="index" :block="block"></table-block>
        </template>

        <template v-if="block.type == 'quote' && !!block.data.text">
          <quote-block :key="index" :block="block"> </quote-block>
        </template>

        <template v-if="block.type == 'warning'">
          <warning-block :key="index" :block="block"></warning-block>
        </template>

        <template>
          <embed-block v-if="block.type == 'embed' && !!block.data.embed" :key="index" :block="block"></embed-block>
        </template>

        <template v-if="block.type == 'attaches'">
          <attaches-block :key="index" :block="block"></attaches-block>
        </template>

        <template v-if="block.type == 'list'">
          <list-block :key="index" :block="block"></list-block>
        </template>

        <template v-if="block.type == 'checklist'">
          <checklist-block :key="index" :block="block"></checklist-block>
        </template>
      </template>

      <div class="wrapper">
        <div class="d-flex text-right-des">
          <yandex-share :services="['facebook', 'linkedin', 'telegram', 'whatsapp']" class="social-wrap" counter />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AttachesBlock from "./blocks/AttachesBlock";
import ChecklistBlock from "./blocks/ChecklistBlock";
import EmbedBlock from "./blocks/EmbedBlock";
import HeaderBlock from "./blocks/HeaderBlock";
import ImageBlock from "./blocks/ImageBlock";
import ListBlock from "./blocks/ListBlock";
import ParagraphBlock from "./blocks/ParagraphBlock";
import QuoteBlock from "./blocks/QuoteBlock";
import TableBlock from "./blocks/TableBlock";
import WarningBlock from "./blocks/WarningBlock";
import YandexShare from "@cookieseater/vue-yandex-share";

export default {
  props: ["slug", "lang", "trans", "value"],
  name: "TestPageComponent",
  components: {
    AttachesBlock,
    ChecklistBlock,
    EmbedBlock,
    HeaderBlock,
    ImageBlock,
    ListBlock,
    ParagraphBlock,
    QuoteBlock,
    TableBlock,
    WarningBlock,
    YandexShare,
  },
  data() {
    return {
      article: null,
    };
  },
  mounted() {
    if (this.value === undefined || this.value === null) {
      this.loadArticle(this.slug);
    } else {
      this.article = this.prepareBlocks(this.value);
    }
  },
  computed: {
    blocks() {
      if (!!this.article) {
        return this.article.content.blocks;
      }
      return [];
    },
  },
  methods: {
    loadArticle(slug) {
      const urlParams = new URLSearchParams(window.location.search);

      var url = "/api/test-page";
      var params = urlParams.toString();

      if (params.length) {
        url += "?" + params;
      }

      axios
        .get(url)
        .then((response) => {
          this.article = this.prepareBlocks(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    goBack() {
      if (document.referrer === "") {
        window.location.href = `/${this.lang}/news`;
      } else {
        history.back();
      }
    },
    prepareBlocks(data) {
      var blocks = [];
      var last = null;

      data.content.blocks.forEach((block) => {
        if (
          block.type === "paragraph" ||
          block.type === "attaches" ||
          (block.type === "image" && block.data.file.mime_type.startsWith("image/"))
        ) {
          if ((last && last.type !== block.type) || (block.type === "image" && !!block.data.stretched)) {
            last = null;
          }

          var skip = !!last;

          if (!last) {
            last = {
              type: block.type,
              data: {
                items: [],
              },
              tunes: block.tunes,
            };
          }

          last.data.items.push(block.data);

          if (skip) {
            return;
          }
        } else {
          last = null;
        }

        blocks.push(last || block);

        if (block.type === "image" && block.data.file.mime_type.startsWith("image/") && !!block.data.stretched) {
          last = null;
        }
      });

      data.content.blocks = blocks;

      return data;
    },
  },
  watch: {
    slug: {
      handler: function (slug) {
        if (slug !== this.article.slug) {
          this.loadArticle(slug);
        }
      },
    },
  },
};
</script>

<style lang="scss">
.plyr {
  --plyr-color-main: #474747;
}

@import "plyr";
</style>
<style lang="scss" scoped>
.w-mb {
  margin-bottom: 50px;
}

.w-mb2 {
  margin-bottom: 100px;
}
</style>
